<script>
import { forEach } from 'lodash';
import constants from '@/constants';

export default {
  name: 'whatsNews',
  components: {
  },
  data() {
    return {
      messageList: [],
      ready: false,
    };
  },
  created() {
    this.domain = constants.DOMAIN;
    this.messageList = [];
    forEach(this.$t('message.information.whatsNews'), (v) => {
      this.messageList.unshift(v);
    });
    setTimeout(()=> {
      this.ready = true;
    }, 1);
  },
};
</script>

<template>
  <div class="whats-news" v-if="ready" :class="$mq">
    <p v-for="(mes, i) in messageList" :key="`mes${i}`"
      :title="mes.text"
    >
      <span v-if="mes.url===''">{{mes.text}}</span>
      <a v-if="mes.url!==''"
        class="is-link" 
        :target="mes.url.match(domain) ? '' : '_blank'"
        :href="mes.url"
      >
        {{mes.text}}
      </a>
    </p>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .whats-news {
    height: 50%;
    margin: 0 auto;
    margin-top: 30px;
    text-align: center;
    overflow-y: auto;

    .is-link {
      text-decoration: underline;
      transition: 0.5s ease;
      &:hover {
        color: $accentColor2;
      }
    }
    // responsible -----------------------------------------------
    &.viewLg {
      width: 70%;
      line-height: 30px;
    }
    &.viewMd {
      width: 100%;
      font-size: 0.9em;
      line-height: 25px;
    }
    &.viewSm {
      width: 100%;
      height: 70%;
      font-size: 0.9em;
      line-height: 25px;
    }
  }
</style>
